import { isLeft } from "fp-ts/lib/Either";
import type * as t from "io-ts";

import { PayloadValidationError } from "./error";

export * from "./error";

/**
 * Calculate exponential backoff from 250ms - 30s
 * @param count Starting from 1, delays are: 250, 500, 1500, 3500, 7500, 15500, 30000
 * @param limit Maximum number of miliseconds
 * @returns Number of miliseconds
 */
export function calculateExponentialBackoff(count: number, limit = 30000) {
  return Math.min(0.5 * 1.5 ** count - 0.5, limit / 1000) * 1000;
}

/**
 * Decode a potential input payload into a particular type, using an io-ts schema
 * If decoding fails, throw a useful exception, otherwise return the decoded type
 */
export function validateOrThrow<I>(inputType: t.Type<I>, payload: unknown): I {
  const validationResult = inputType.decode(payload);

  // Left = error
  // https://github.com/gcanti/io-ts/blob/master/index.md#the-idea
  if (isLeft(validationResult)) {
    throw new PayloadValidationError(validationResult.left);
  }

  return validationResult.right;
}
